import { render, staticRenderFns } from "./AvatarSize.vue?vue&type=template&id=50286823"
import script from "./AvatarSize.vue?vue&type=script&lang=js"
export * from "./AvatarSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports